import 'boxicons';
import screenfull from 'screenfull';
import 'zenscroll'

window.screenfull = screenfull;

require('./bootstrap');
require('./dashboard');

